(() => {
  const getThumbnails = (gallery) => Array.from(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));

  const updateHeight = (state, activeItem = null) => {
    if (!state.mediaList) return;
    if (!state.mobileMedia.matches) {
      state.mediaList.style.removeProperty('height');
      return;
    }
    const item = activeItem || state.currentItem || state.mediaList.querySelector('.product__media-item.is-active');
    const media = item?.querySelector('.product-media-container');
    if (!item || !media) return;
    state.currentItem = item;
    const styles = window.getComputedStyle(item);
    const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
    const height = Math.ceil(media.getBoundingClientRect().height + padding);
    if (height > 0) state.mediaList.style.height = `${height}px`;
  };

  const updateMoreButton = (state) => {
    if (!state.moreButton || !state.thumbnailList) return;
    const max = Math.max(0, state.thumbnailList.scrollHeight - state.thumbnailList.clientHeight);
    const showUp = state.thumbnailList.scrollTop >= max - 2 && max > 0;
    if (!showUp && state.thumbnailList.scrollTop > 2) return;
    state.moreButton.dataset.scrollDirection = showUp ? 'up' : 'down';
    state.moreButton.classList.toggle('restore-thumbnail-more--up', showUp);
    state.moreButton.setAttribute('aria-label', showUp ? 'Show previous product thumbnails' : 'Show more product thumbnails');
  };

  const moveGallery = (state, button) => {
    const items = getThumbnails(state.gallery);
    if (!items.length) return;
    const current = items.findIndex((item) => item.getAttribute('aria-current') === 'true');
    const direction = button.dataset.restoreGalleryDirection === 'next' ? 1 : -1;
    const next = ((current < 0 ? 0 : current) + direction + items.length) % items.length;
    items[next].click();
    items[next].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  const scrollThumbnails = (state) => {
    if (!state.thumbnailList) return;
    const firstItem = state.thumbnailList.querySelector('.thumbnail-list__item');
    const step = firstItem ? firstItem.offsetHeight * 3 : state.thumbnailList.clientHeight * 0.75;
    const direction = state.moreButton.dataset.scrollDirection === 'up' ? -1 : 1;
    const max = Math.max(0, state.thumbnailList.scrollHeight - state.thumbnailList.clientHeight);
    state.thumbnailList.scrollTo({ top: Math.min(max, Math.max(0, state.thumbnailList.scrollTop + direction * step)), behavior: 'smooth' });
  };

  const bindGalleryEvents = (state) => {
    const { gallery, signal } = state;
    gallery.querySelectorAll('[data-restore-gallery-direction]').forEach((button) => {
      button.addEventListener('click', () => moveGallery(state, button), { signal });
    });
    state.moreButton?.addEventListener('click', () => scrollThumbnails(state), { signal });
    state.thumbnailList?.addEventListener('scroll', () => updateMoreButton(state), { passive: true, signal });
    state.viewer?.addEventListener('slideChanged', (event) => updateHeight(state, event.detail.currentElement), { signal });
    window.addEventListener('resize', () => {
      updateMoreButton(state);
      updateHeight(state);
    }, { signal });
  };

  const bindThumbnailEvents = (state) => {
    getThumbnails(state.gallery).forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const target = thumbnail.closest('[data-target]')?.dataset.target;
        const activeItem = target ? state.gallery.querySelector(`[data-media-id="${target}"]`) : null;
        requestAnimationFrame(() => updateHeight(state, activeItem));
      }, { signal: state.signal });
    });
  };

  const initializeGallery = (gallery) => {
    if (gallery.dataset.restoreControlsReady === 'true') return;
    gallery.dataset.restoreControlsReady = 'true';
    const events = new AbortController();
    const state = {
      gallery,
      signal: events.signal,
      viewer: gallery.querySelector('[id^="GalleryViewer-"]'),
      mediaList: gallery.querySelector('[id^="Slider-Gallery-"]'),
      thumbnailList: gallery.querySelector('[id^="Slider-Thumbnails-"]'),
      moreButton: gallery.querySelector('[data-restore-thumbnail-more]'),
      mobileMedia: window.matchMedia('(max-width: 749px)'),
      currentItem: null,
    };
    bindGalleryEvents(state);
    bindThumbnailEvents(state);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(gallery)) events.abort();
    }, { signal: state.signal });
    updateMoreButton(state);
    requestAnimationFrame(() => updateHeight(state));
  };

  document.querySelectorAll('[data-restore-thumbnail-more]').forEach((button) => {
    const gallery = button.closest('media-gallery');
    if (gallery) initializeGallery(gallery);
  });
})();
